import n4js from "refractor/n4js";
export default n4js;